import { styled } from "@mui/material";

import { IFullWidthCardImage } from "../types";

export const StyledFullWidthProductImage = styled("div", {
  shouldForwardProp: prop => prop !== "src",
})<IFullWidthCardImage>`
  background-color: ${({ src, theme }) => (src ? theme.modernCardBackground : theme.modernPageBackground)};
  min-height: 132px;
  position: relative;
  width: 100%;

  &::before {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    bottom: 0px;
    ${({ src }) => src && `background-image:url(${src})`};
    content: "";
    filter: blur(2px);
    left: 0px;
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 0;
  }

  ${({ overlay }) =>
    overlay &&
    `
    &::after{
      background: rgba(0, 0, 0, 0.50);
      bottom: 0px;
      content: "";
      left: 0px;
      position: absolute;
      right: 0px;
      top: 0px;
      z-index: 0;
    }

  `};
`;
